import { create } from 'zustand';
import { DEFAULT_SETTINGS, normalizeSettings, type Settings } from './settingsModel';
import { db } from '@/db/db';

interface SettingsState {
  settings: Settings;
  loaded: boolean;
  load: () => Promise<void>;
  update: (patch: Partial<Settings>) => Promise<void>;
  /** Replace all settings (sync from server). */
  replace: (s: Settings) => Promise<void>;
}

export const useSettings = create<SettingsState>((set, get) => ({
  settings: DEFAULT_SETTINGS,
  loaded: false,
  async load() {
    try {
      const row = await db.settings.get('settings');
      set({ settings: normalizeSettings(row?.value), loaded: true });
    } catch {
      set({ loaded: true });
    }
  },
  async update(patch) {
    const next = normalizeSettings({ ...get().settings, ...patch, updatedAt: Date.now() });
    set({ settings: next });
    await db.settings.put({ key: 'settings', value: next });
  },
  async replace(s) {
    const next = normalizeSettings(s);
    set({ settings: next });
    await db.settings.put({ key: 'settings', value: next });
  },
}));

/** Non-React accessor for the hot path. */
export function getSettings(): Settings {
  return useSettings.getState().settings;
}
